import types from '../types';
import * as chatEventEmitter from '../../services/chat-event-emitter.service';
var MessagesActions = /** @class */ (function () {
    function MessagesActions(serverApi) {
        this.serverApi = serverApi;
    }
    MessagesActions.prototype.action$fetchDrillInMessageIndications = function (chatroomId, sequence) {
        return {
            type: types.FETCH_DRILL_IN_MESSAGE_INDICATIONS,
            payload: this.serverApi.http$fetchDrillInMessageIndications(chatroomId, sequence).then(function (drillInInMessageIndications) {
                chatEventEmitter.emit(chatEventEmitter.CHAT_INTERNAL_EVENTS.FETCH_DRILL_IN_MESSAGE_INDICATIONS_COMPLETED, drillInInMessageIndications);
                return drillInInMessageIndications;
            })
        };
    };
    MessagesActions.prototype.action$updateMessagesIndications = function (payload) {
        return {
            type: types.UPDATE_MESSAGES_INDICATIONS,
            payload: payload
        };
    };
    MessagesActions.prototype.action$fetchRoomParticipantsDisplayData = function (chatroomId, participantIds) {
        return {
            type: types.FETCH_PARTICIPANTS_DISPLAY_DATA,
            payload: this.serverApi.http$fetchParticipantsDisplayData({ chatroomId: chatroomId, participantIds: participantIds })
        };
    };
    return MessagesActions;
}());
export { MessagesActions };
var messagesActionsFactory = function (serverApi) {
    return new MessagesActions(serverApi);
};
export default messagesActionsFactory;
